import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// import image10 from '../assets/newHeader/image23.jpg';
import whyThisImg from '../assets/public-site/Character_1.png';
import hiwImg from '../assets/public-site/charater_2.png';
import wygImg1 from '../assets/public-site/Group_1.svg';
import wygImg2 from '../assets/public-site/Group_2.svg';
import wygImg3 from '../assets/public-site/Group_3.svg';
import wygImg4 from '../assets/public-site/Group_4.svg';
import drivingChanges from '../assets/public-site/Group_6.png';
import introImg from '../assets/public-site/Logisticsintro.jpg';
import { ExportedIcon } from '../components/icons/icons';
import { NewFooter } from '../components/Layout/NewFooter';
import { NewNavbar } from '../components/Layout/NewHeader';

import { ConnectForm } from './ConnectUseForm';

export const Logistics: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div>
      {/* header */}
      <NewNavbar />

      {/* hero section */}
      <section
        className="
    relative w-full h-screen bg-cover bg-center bg-no-repeat 
    before:absolute before:inset-0 before:z-10 
    lg:before:hidden
    before:bg-gradient-to-r before:from-black before:to-transparent
  "
        style={{
          backgroundImage: `
            linear-gradient(180deg, rgba(0, 0, 0, 0) 47.64%, #000000 100%),
            url(${introImg})
          `,
        }}
      >
        <div className="relative z-20 flex items-end justify-center h-full container mx-auto px-6 pb-10 text-white text-center">
          <div className="w-full space-y-6">
            <h1 className="text-4xl sm:text-5xl font-normal">
              Predict who will show up, succeed, and stay
              <span className="text-[#FFC90D] font-bold"> before day one. </span>
            </h1>
            <p className="mt-2 text-lg sm:text-xl !leading-loose font-semibold">
              Vero is a predictive workforce intelligence platform for logistics leaders who want to
              build shift-stable teams with real-world precision-not guesswork.
            </p>

            <a
              href="https://meetings.hubspot.com/chrissybil/vero-learning"
              className="btn btn-primary !px-9 !py-6 hover:underline rounded-md inline-flex items-center gap-2"
              target="_blank"
              rel="noopener noreferrer"
            >
              Schedule a Strategy Session <ExportedIcon />
            </a>
          </div>
        </div>
      </section>

      {/* Why This Still Hurts Section */}
      <section className="py-16">
        <div className="container px-4">
          <div className="mb-10">
            <h2 className="text-3xl text-center sm:text-4xl md:text-5xl lg:text-6xl font-normal mb-4 !leading-tight">
              High churn shouldn't be
              <span className="font-bold text-primary-500"> your normal.</span>
            </h2>
            <hr className="my-9 border-gray-300" />
            <p className="text-2xl font-normal text-center sm:text-lg md:text-3xl !leading-loose">
              In warehousing, fulfillment, and supply chain ops, speed is everything-but reactive
              hiring slows you down. Burnout, absenteeism, and constant retraining cost more than
              time. You don’t just need to fill roles. You need to fill them right.
            </p>
            <hr className="my-9 border-gray-300" />
          </div>
          <br />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center mt-8">
            {/* Left Content */}

            <div>
              <div className="mx-auto mt-5">
                <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light leading-tight lg:!leading-[75px] mb-5 text-center lg:text-left">
                  Traditional tools filter people out.
                  <span className="font-bold text-primary-500"> Vero lifts the right ones up.</span>
                </h2>
              </div>
              <div className=" pb-7 pt-4">
                <p className="text-black font-normal text-xl leading-[40px] text-center lg:text-left">
                  We surface talent based on natural competencies, not just resumes—like
                  follow-through, team reliability, and long-term motivation. That means stronger
                  hires, faster adaptation, and fewer costly surprises.
                </p>
              </div>

              <a
                className="btn btn-secondary !whitespace-normal !py-6 !px-8"
                href="https://meetings.hubspot.com/chrissybil/vero-learning"
                target="_blank"
              >
                Explore smarter shift staffing <ExportedIcon />
              </a>
            </div>

            {/* Right Image */}
            <div className="relative w-full">
              <img
                src={whyThisImg}
                alt="Team Collaboration"
                className="w-full h-auto object-cover rounded-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className=" py-16 bg-[#E6E8FE]">
        <div className="container mx-auto text-center md:text-left">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light leading-tight lg:!leading-[83px] mb-5">
            Built for shift managers.
            <span className="text-primary-500 font-bold m-2 ">
              {' '}
              Backed <br />
              by real-world signals.
            </span>
          </h2>
          <p className="text-3xl">Vero helps logistics teams:</p>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 ">
            {/* Left Column - Text */}
            <div className="mx-auto md:mt-10 items-center gap-10">
              <div className="col-span-1 text-center md:text-left space-y-6">
                {[
                  {
                    title: 'Match candidates faster—and smarter:',
                    desc: `by using the traits of your highest-retaining workers.`,
                  },
                  {
                    title: 'Avoid overhiring and retraining:',
                    desc: `Know who’s likely to succeed—before day one.`,
                  },
                  {
                    title: 'Help schedulers plan with foresight:',
                    desc: `Give leaders visibility into shift fit, physical demands, and role alignment.`,
                  },
                  {
                    title: 'Grow loyalty from the ground up:',
                    desc: `Spot upward mobility early, reduce churn, and invest where it matters most.`,
                  },
                ].map((item, index) => (
                  <div
                    key={index}
                    className="border-dashed border border-purple-200 rounded-[32px] p-7"
                  >
                    {/* <h3 className="text-2xl mb-2 font-bold">{item.title}</h3> */}
                    <p className=" text-xl font-normal text-black">
                      {' '}
                      <strong>{item.title}</strong> {item.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* Right Column - Images */}
            <div className="relative w-full flex items-center justify-center">
              <img
                src={hiwImg}
                alt="Team Logistics"
                className="w-full 2xl:w-3/4 h-auto object-contain rounded-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* What You Get Section */}
      <section className="pb-16 mt-10">
        <div className="container">
          {/* <p className="text-2xl text-center mb-4">Who We Support</p> */}
          <h2 className="text-4xl sm:text-5xl font-normal md:text-6xl text-center mb-8">
            How Vero Works for
            <span className="text-primary-500  font-bold"> Logistics Teams</span>
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Employer Card 1 */}
            <div className="col-span-1 px-6 py-12 rounded-[40px] bg-primary-200 flex flex-col items-center gap-4 text-center">
              <div className="h-60">
                <img
                  src={wygImg1}
                  alt="For Employers Who Look Beyond the Hire"
                  className="w-full h-auto"
                  loading="lazy" // Added lazy loading for better performance
                />
              </div>
              <h3 className="text-2xl font-medium mt-2">
                Define what reliable looks <br /> like
              </h3>
              <p className="text-center text-lg !leading-loose">
                We analyze shift attendance, performance feedback, and retention trends to profile
                your highest-retaining workers.
              </p>
            </div>
            {/* Employer Card 2 */}
            <div className="col-span-1 px-6 py-12 rounded-[40px] bg-primary-200 flex flex-col items-center gap-3 text-center">
              <div className="h-60">
                <img
                  src={wygImg2}
                  alt="For Employers Who Look Beyond the Hire"
                  className="w-full h-auto"
                  loading="lazy" // Added lazy loading for better performance
                />
              </div>
              <h3 className="text-2xl font-medium mt-2">
                Surface overlooked <br /> strengths
              </h3>
              <p className="  text-center text-lg !leading-loose">
                Vero identifies coachable, motivated candidates who may be missed by resume
                filters-but are built for the role.
              </p>
            </div>
            {/* Employer Card 3 */}
            <div className="col-span-1 px-6 py-12 rounded-[40px] bg-primary-200 flex flex-col items-center gap-3 text-center">
              <div className="h-60">
                <img
                  src={wygImg3}
                  alt="For Employers Who Look Beyond the Hire"
                  className="w-full h-auto"
                  loading="lazy" // Added lazy loading for better performance
                />
              </div>
              <h3 className="text-2xl font-medium mt-2">
                Match based on role <br />
                demands
              </h3>
              <p className="  text-center text-lg !leading-loose">
                Our AI aligns candidates with the physical, behavioral, and supervisory realities of
                the job-not just who’s available.
              </p>
            </div>
            {/* Employer Card 4 */}
            <div className="col-span-1 px-6 py-12 rounded-[40px] bg-primary-200 flex flex-col items-center gap-3 text-center">
              <div className="h-60">
                <img
                  src={wygImg4}
                  alt="For Employers Who Look Beyond the Hire"
                  className="w-full h-auto"
                  loading="lazy" // Added lazy loading for better performance
                />
              </div>
              <h3 className="text-2xl font-medium mt-2 ">
                Improve with every <br /> cycle
              </h3>
              <p className="  text-center text-lg !leading-loose">
                Every placement sharpens the model. The more you use Vero, the more resilient your
                workforce becomes.
              </p>
            </div>
          </div>

          {/* Button Section */}
          <div className="mt-12 text-center ">
            <a
              className="btn btn-secondary md:py-6 md:px-7 "
              href="https://meetings.hubspot.com/chrissybil/vero-learning"
              target="_blank"
            >
              Start reducing retraining and <br /> <br /> no-shows <ExportedIcon />
            </a>
          </div>
        </div>
      </section>

      <section className="pb-16">
        <div className="container px-4">
          <div className="grid grid-cols-1 lg:grid-cols-[35%_65%] gap-10 items-center mt-12">
            {/* Left Image */}
            <div className="relative w-full flex items-center justify-center">
              <img
                src={drivingChanges}
                alt="driving Changes"
                className="w-full 2xl:w-3/4 h-auto object-contain rounded-xl"
              />
            </div>
            {/* Right Content */}
            <div className="mx-auto md:mt-10 items-center gap-10">
              {/* Right Column - Text */}
              <div className="mx-auto text-center lg:text-left">
                <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light leading-tight lg:!leading-[75px] mb-5">
                  Why Logistics Teams
                  <span className="font-bold text-primary-500 block"> Choose Vero</span>
                </h2>
              </div>
              <div className="text-center md:text-left space-y-6">
                {[
                  {
                    list: [
                      '85% AI job fit accuracy based on employer-validated success signals',
                      'Trained on real-world reliability, not just HR benchmarks',
                      'Inclusive of first-time workers and nontraditional talent',
                      'Learns from your ops—not someone else’s playbook',
                      'Used by 35,000+ team leaders across logistics, healthcare, retail, and manufacturing',
                    ],
                  },
                ].map((item, index) => (
                  <div key={index} className="mt-4">
                    {item.list && (
                      <ul className="text-black mt-4 text-xl list-disc list-outside font-normal leading-loose pl-5 text-left">
                        {item.list.map((point, i) => (
                          <li key={i}>{point}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>
              <div className="mt-12 text-center md:text-left !md:text-sm ">
                <a
                  className="btn btn-secondary !py-6 !px-7"
                  href="https://meetings.hubspot.com/chrissybil/vero-learning"
                  target="_blank"
                >
                  Book your strategy session now
                  <ExportedIcon />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* container 13 */}
      <ConnectForm
        text="Logistics isn’t just about movement—it’s about stability, trust, and precision. Vero helps you hire for all three."
        header="Let’s build your momentum."
        buttonText="Book time here"
        actionButtonText="Schedule a live demo"
      />
      <NewFooter />
    </div>
  );
};
